/**
 * Tabla de modelos de fresas: cambia entre pulgadas y mm.
 * Recuerda la elección del visitante en esta sesión.
 */
class TablaModelos extends HTMLElement {
  connectedCallback() {
    let guardada = null;
    try {
      guardada = sessionStorage.getItem('toolstore-tabla-unidad');
    } catch {
      /* sin almacenamiento */
    }
    this.mostrar(guardada || this.dataset.unidad || 'pulgadas');
    this.addEventListener('click', (event) => {
      const boton = event.target instanceof Element ? event.target.closest('[data-unidad-boton]') : null;
      if (!boton) return;
      const unidad = boton.getAttribute('data-unidad-boton');
      this.mostrar(unidad);
      try {
        sessionStorage.setItem('toolstore-tabla-unidad', unidad);
      } catch {
        /* sin almacenamiento */
      }
    });
  }

  mostrar(unidad) {
    this.dataset.unidad = unidad;
    for (const boton of this.querySelectorAll('[data-unidad-boton]')) {
      boton.setAttribute('aria-pressed', String(boton.getAttribute('data-unidad-boton') === unidad));
    }
  }
}

if (!customElements.get('tabla-modelos')) customElements.define('tabla-modelos', TablaModelos);
